// ANGEL FLIGHT — M2: Night Raid (the second mission, a cold-blue contrast to M1).
//
// Deep night over a dead downtown. The horde swells in the dark — tracers, muzzle
// flash, and the burning skyline are the only light. Harder + longer than M1, with
// more runners + RPG shooters (screamers) AND street riflemen (marauders) chipping
// the bird from cover, so target discipline + weapon-switching matter. Friendlies
// push through the dark too.
//
// Pure data. The `night-city` theme drives the cold palette (see config/render.ts
// themes); the ColorWorld reads it.

import type { MissionDef } from '../core/types';

export const nightRaid: MissionDef = {
  id: 'm2-night-raid',
  name: 'Night Raid',
  biome: 'Dead Downtown — Night',
  objective: 'survive',
  theme: 'night-city',
  durationMs: 110_000,
  brief:
    'Downtown, lights out. RPG teams in the dark — put them down first. Friendlies in the open — CHECK YOUR FIRE. Hold until exfil.',
  waves: [
    { atMs: 1_500, spawns: { shambler: 5 }, banner: 'CONTACT — LIGHTS OUT' },
    { atMs: 10_000, spawns: { runner: 4, shambler: 4 } },
    { atMs: 20_000, spawns: { screamer: 2, runner: 4, trooper: 1 }, banner: 'RPG TEAMS' },
    { atMs: 32_000, spawns: { runner: 6, shambler: 5, marauder: 2, trooper: 1 }, banner: 'STREET RIFLEMEN' },
    { atMs: 45_000, spawns: { spitter: 3, runner: 4, brute: 1 }, banner: 'SPITTERS' },
    { atMs: 58_000, spawns: { screamer: 3, runner: 6, trooper: 2 }, banner: 'THEY SEE THE BIRD' },
    { atMs: 72_000, spawns: { shambler: 8, runner: 6, marauder: 2, brute: 1 } },
    { atMs: 88_000, spawns: { runner: 9, screamer: 3, marauder: 3, brute: 2, trooper: 2 }, banner: 'THE SWARM' },
  ],
};
